import "core-js/modules/es.array.push.js";
const moment = require('moment');
export default {
  data() {
    return {
      errorTimes: 0,
      websock: null,
      imgUrl: require('../../../assets/nav/user.gif'),
      socketStatus: 'webSocket连接断开',
      newsList: [{
        user: 'admin',
        imgUrl: require('../../../assets/nav/user.gif'),
        message: 'hello',
        date: '2020-12-27 15:36:24'
      }, {
        user: 'robot',
        imgUrl: require('../../../assets/nav/robot.png'),
        message: 'hello',
        date: '2020-12-27 15:36:24'
      }],
      textValue: ''
    };
  },
  created() {
    this.init();
  },
  destroyed() {
    this.websock.close();
  },
  methods: {
    init() {
      if (typeof WebSocket === 'undefined') {
        alert('您的浏览器不支持socket');
        return;
      }
      this.websock = new WebSocket('ws://123.207.136.134:9010/ajaxchattest');
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      this.errorTimes = 0;
      this.socketStatus = 'webSocket已连接';
    },
    //数据接收
    websocketonmessage(e) {
      this.socketStatus = '输入中...';
      setTimeout(() => {
        this.newsList.push({
          user: 'robot',
          imgUrl: require('../../../assets/nav/robot.png'),
          message: e.data,
          date: moment().format('YYYY-MM-DD HH:mm:ss')
        });
        this.socketStatus = 'webSocket已连接';
        this.$nextTick(() => {
          const boxDom = this.$refs['scrollBar'].wrap;
          boxDom.scrollTop = boxDom.scrollHeight;
        });
      }, 350);
    },
    //数据发送
    websocketsend(message) {
      this.websock.send(message);
      this.newsList.push({
        user: 'admin',
        imgUrl: require('../../../assets/nav/user.gif'),
        message: message,
        date: moment().format('YYYY-MM-DD HH:mm:ss')
      });
      this.textValue = '';
    },
    websocketonerror() {
      if (this.errorTimes == 2) {
        this.$message.error('连接失败,请稍后重试');
        this.socketStatus = 'webSocket连接失败';
        return;
      }
      this.errorTimes++;
      console.log('连接失败,正在重新连接');
      this.init();
    },
    websocketclose(e) {
      this.socketStatus = 'webSocket连接断开';
      console.log('断开了连接', e);
    },
    changeText(e) {
      this.textValue = e.target.value;
    },
    sendNews() {
      if (!this.textValue) {
        this.$message.warning('输入内容不能为空');
        return;
      }
      this.websocketsend(this.textValue);
    }
  }
};